import React, { Component } from 'react';
import { Route, Routes } from 'react-router-dom';
import AppRoutes from './AppRoutes';
import Login from './components/Layout/Login';
import './custom.css';
import Protected from './Protected';
import EventSelection from './components/ORIDownloadProcess/EventSelection';
import ManagementSystem from './components/ORIDownloadProcess/ManagementSystem';
import DownloadProcess from './components/ORIDownloadProcess/DownloadProcess';

export default class App extends Component {
    static displayName = App.name;

    render() {
        return (
            <Routes>
                <Route path='/' element={<ManagementSystem />} />
                <Route path='/OnlineManagementSystem' element={<ManagementSystem />} />
                <Route path='/Admin' element={<Login />} />
                <Route path='/EventSelection' element={<EventSelection />} />
                <Route path='/DownloadProcess' element={<DownloadProcess />} />
                {AppRoutes.map((item, index) =>
                    <Route path={`/${item.path}`} key={`menus${index}`} element={<Protected Component={item.element} PageUrl={item.path} />} />
                )}
            </Routes>
        );
    }
}
